<template>
  <svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M15.4563 -0.00012207H0.543719C0.243437 -0.00012207 0 0.23821 0 0.532194V8.46756C0 8.76155 0.243437 8.99988 0.543719 8.99988H15.4563C15.7566 8.99988 16 8.76155 16 8.46756V0.532194C16 0.23821 15.7566 -0.00012207 15.4563 -0.00012207Z"
        fill="currentColor"/>
    <path
        d="M11.4728 12.9999H9V10.9999H7V12.9999H4.5C4.20886 12.9999 4 13.1884 4 13.4999C4 13.8114 4.23602 13.9999 4.52719 13.9999H11.4728C11.7639 13.9999 12 13.8114 12 13.4999C12 13.1884 11.764 12.9999 11.4728 12.9999Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconMonitor"
}
</script>

<style scoped>

</style>